import { createContext } from 'react'
import { ArtboardCropPosition } from './types'

type CreationToolsArtboardContextProps = {
    frameCount: number
    renderingContext: CanvasRenderingContext2D | null
    canvasScale: number
    crop?: ArtboardCropPosition
    setCrop: (crop?: ArtboardCropPosition) => void
    draggingCaptionId: string | undefined
    setDraggingCaptionId: (id: string | undefined) => void
    contextMenuCaptionId: string | undefined
    setContextMenuCaptionId: (id: string | undefined) => void
}

export const CreationToolsArtboardContext = createContext({} as CreationToolsArtboardContextProps)
